/* eslint-disable no-underscore-dangle */

import { useMutation } from '@apollo/client';

import {
  Ad,
  Mutation,
  MutationFreeActivateResumeArgs,
  MutationFreeActivateVacancyArgs
} from '@/__generated_graphql__/types';
import { AD_TYPE } from '@/constants/common';
import { FREE_ACTIVATE_RESUME } from '@/graphql/mutations/resume.mutations';
import { FREE_ACTIVATE_VACANCY } from '@/graphql/mutations/vacancy.mutations';

type ActivateMutation =
  | Mutation['freeActivateResume']
  | Mutation['freeActivateVacancy'];

type ActivateVariables =
  | MutationFreeActivateResumeArgs
  | MutationFreeActivateVacancyArgs;

type Props = {
  ad: Pick<Ad, '__typename' | 'id'>;
  succesCallback?: () => void;
  errorCallback?: () => void;
};
export const useFreeActivate = (props: Props) => {
  const { ad, succesCallback, errorCallback } = props;
  const isResume = ad?.__typename === AD_TYPE.RESUME;

  const computedQuery = isResume ? FREE_ACTIVATE_RESUME : FREE_ACTIVATE_VACANCY;

  const [freeActivate, { loading, error }] = useMutation<
    ActivateMutation,
    ActivateVariables
  >(computedQuery);

  const activate = async () => {
    try {
      if (!ad.id) return;
      const res = await freeActivate({ variables: { id: ad.id } });
      const callback = res?.errors ? errorCallback : succesCallback;
      return callback?.();
    } catch (e) {
      console.error(
        `Error during free activate ${ad.__typename}`,
        e instanceof Error ? error?.message : e
      );
      errorCallback?.();
    }
  };

  return { activate, loading, error };
};
